export module App {
    export class AppConfig {
        public static isDev = false;
        public static apiEndPoint = "https://rcs-vouchers-tool.renault.worldline-solutions.com";
        public static keycloakConfig = {
            "url": "https://rcs-keycloak.renault.worldline-solutions.com",
            "realm": "RCS",
            "clientId": "voucher",
        };
    }
}
